import React, { FC } from 'react';
import styleModule from './RecruiterLandingStepsSection.module.less';
import Link from 'next/link';
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from 'antd';
import Image from 'next/image';
import { RightOutlined } from '@ant-design/icons';
import { useUserInfo } from '../../../connection/Application';
import { Title } from '../../../components/Typogrphy/Title';
import { PlusOutlined } from '@ant-design/icons';
import { useRouter } from 'next/router';
import Externallink from '../../../public/recruiter/recruiter-landing/externallink.svg';
import background from '../../../public/recruiter/recruiter-landing/Stepsimage.png';
const styles: any = styleModule;

export const RecruiterLandingStepsSection: FC = () => {
  const user = useUserInfo();
  const history = useRouter();
  return (
    <section
      className={`relative w-screen self-center flex justify-center mt-[-20px]  text-[#050931] ${styles.SectioCont}`}>
      <div className={styles.topSectionLeft} />
      <div className={styles.topSectionRight} />
      <div className="w-full max-w-[1600px] px-[20px] md:px-[65px] py-[40px] flex items-center z-10 flex-col lg:flex-row gap-8 lg:gap-0">
        <div className={`grow shrink z-10 ${styles.bannerTextCont}`}>
          <Image
            src={background}
            alt={'Banner Background'}
            className={styles.StepsImage}
            style={{
              color: 'transparent',
              position: 'inherit',
              width: '555px',
              height: '470px',
              marginLeft: '-20px',
              // margin: 'auto',
            }}
          />
        </div>
        <div
          className={`grow shrink flex items-center justify-center z-0 ${styles.bannerImageCont}`}>
          <div className={styles.topRightDiv}>
            <span className={styles.Heading}>
              <span style={{ color: '#009E52' }}>3 steps </span>to hiring your <br /> perfect
              candidate
            </span>
            <div className={styles.steps}>
              <div className={styles.step}>
                <div
                  style={{ backgroundColor: '#5CC090', color: 'white' }}
                  className={styles.square}>
                  1
                </div>
                <div className={styles.label1st}>
                  Sign Up{' '}
                  <Image
                    className={styles.logo}
                    src={Externallink}
                    width={20}
                    height={20}
                    alt={'Exernal Link Icon'}
                  />
                </div>
                <div className={styles.line}></div>
              </div>
              <div className={styles.step}>
                <div className={styles.square}>2</div>
                <div className={styles.label}>Create Recruiter Profile</div>
                <div className={styles.line}></div>
              </div>
              <div className={styles.step}>
                <div className={styles.square}>3</div>
                <div className={styles.label}>Post Job Advert</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
